import {safeproMiddleWare} from "axiosApi";
import {useCallback, useState} from "react";
import {handleRequestError} from "utils";
import {useUserAuthContext} from "../context/UserAuthContext";

type UpdateResponse = any;

export const useAdminTopUp = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const {userDetails: {token,},} = useUserAuthContext();

    const adminDeposit = useCallback(
        async (businessId: string, amount: string | number): Promise<UpdateResponse> => {
            setError(null);
            if (!businessId || String(businessId).trim() === "") {
                const msg = "Business ID is required.";
                setError(msg);
                return Promise.reject(new Error(msg));
            }
            if (String(amount).trim() === "" || Number.isNaN(Number(amount)) || Number(amount) <= 0) {
                const msg = "Enter a valid positive amount.";
                setError(msg);
                return Promise.reject(new Error(msg));
            }

            setLoading(true);
            try {
                const clientId = process.env.REACT_APP_CLIENT_ID || "";
                // payload matches: { businessId, amount }
                return await safeproMiddleWare.post(
                    `/admin/deposit`,
                    { businessId, amount: Number(amount) },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "client-id": clientId,
                            Authorization: `Bearer ${token}`,
                            "x-api-version": "v1"
                        },
                    }
                );
            }  catch (err: any) {
                const handled = handleRequestError(err);
                const message = handled?.message || handled?.error || String(err?.message || "Update failed");
                setError(message);
                return Promise.reject(handled || err);
            } finally {
                setLoading(false);
            }
        },
        [token]
    );

    return {adminDeposit, loading, error, setError};
};